import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex } from '@shared/components';
import { WithPermission } from '@shared/permissions';
import { dayjs } from '@shared/utils';

import { useExamDistributionByMonth } from '../../providers';
import { ClearExamAssignmentButton } from '../clear-exam-assignment-button';
import { ExamAssigningButton } from '../exam-assigning-button';

export default function ExamDistributionActions() {
  const { year, month } = useExamDistributionByMonth();

  const currentDate = dayjs();
  const viewingDate = dayjs()
    .set('year', year)
    .set('month', month - 1); // month is 0-indexed in dayjs

  // Check if the viewing date is in the current month or later
  // and not the last day of the month
  const shouldDisplayButtons =
    viewingDate.isSameOrAfter(currentDate, 'month') &&
    !currentDate.isSame(viewingDate.endOf('month'), 'date');

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
      {shouldDisplayButtons ? (
        <WithPermission
          requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.EXAM_ASSIGNING.UPDATE}
        >
          <ClearExamAssignmentButton />
          <ExamAssigningButton />
        </WithPermission>
      ) : null}
    </Flex>
  );
}
